import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography, palette: plt }: Theme) =>
  createStyles({
    buttonsCustomMargin: {
      margin: '24px 0 0',
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        fontFamily: 'Roboto',
        minWidth: 112,
        padding: 4,
        margin: '0 8px',
        fontSize: 12,
        fontWeight: typography.fontWeightMedium,
        borderRadius: 4,
      },
    },
    container: {
      marginTop: 40,
    },
    passwordExpire: {
      marginTop: 20,
      marginBottom: 20,
    },
    content: {
      padding: '10px 40px 38px 40px',
      boxSizing: 'border-box',
      '& .MuiTypography-body1': {
        fontSize: '12px !important',
        fontWeight: 500,
      },
      '& .MuiIconButton-label .MuiSvgIcon-root': {
        width: 15,
        height: 15,
      },
      '& .MuiInputLabel-outlined': {
        fontSize: 12,
      },
      '& .MuiFormControlLabel-root.Mui-disabled': { cursor: 'not-allowed' },
    },

    autocomplete: {
      flex: 1,

      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: palette.backgroundWhite,
      },
      '& .MuiOutlinedInput-inputAdornedStart': {
        flex: 1,
        minWidth: 100,
        padding: 0,
        paddingRight: 8,
        height: 40,
      },

      '& .MuiInputBase-root': {
        display: 'inline',
        height: 'auto',
      },
      '& .MuiChip-outlined': { marginTop: 10, marginRight: 3 },
    },
    autocompleteError: {
      '& .MuiFormLabel-root, .MuiFormLabel-root.MuiFocused': {
        color: plt.error.light,
      },
      '& .MuiOutlinedInput-root, .MuiOutlinedInput-root:hover, .MuiOutlinedInput-root.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: plt.error.light,
        },
      },
    },

    errorMessage: {
      padding: 8,
    },

    chipError: {
      color: plt.error.light,
      borderColor: plt.error.light,
    },
    chipIcon: {
      color: plt.error.light,
      fontSize: 14,
      paddingLeft: 4,
    },
    chipDeleteIcon: {
      color: plt.error.light,

      '&:hover': {
        color: plt.error.dark,
      },
    },
    passwordRules: {
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
      '& .MuiCardHeader-root': {
        padding: '6px 10px',
      },
    },
    iconLock: { fontSize: 16, color: palette.deepBlue },
    titleHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '6px 10px',
    },
    title: { marginLeft: 16 },
    subtitle: {
      fontSize: 12,
      fontWeight: 500,
    },
    iconLockAdmin: { fontSize: 16, color: palette.navGreen },
    iconLockSuperAdmin: { fontSize: 16, color: palette.navGray },
    iconLockOperator: { fontSize: 16, color: palette.blue },
    rulesPassword: {
      margin: '10px 0px',
      '& .MuiTypography-body1': {
        margin: '5px 0px',
      },
    },
    infoIcon: {
      fontSize: 15,
      color: palette.gray,
    },
    currentPin: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    currentPinGrid: {
      marginTop: 16,
    },
    titleAndIcon: { display: 'flex', alignItems: 'center', gap: 8 },
  });
